export default "__VITE_ASSET__D$fVVLjT__"